module.exports = __webpack_public_path__ + "static/media/rw.997fe41b.svg";